export enum Roles {
  "SUPER_ADMIN" = "superadmin",
  "INDUK" = "induk",
  "ADMIN" = "admin",
  "CUSTOMER" = "customer",
}
